import { useEffect } from 'react';
import { useTracking } from '@podiumhq/tracking';

const useTrackAmplitudeEvent = (eventToTrackOnLoad) => {
  const { trackEvent } = useTracking();

  useEffect(() => {
    eventToTrackOnLoad && trackEvent(eventToTrackOnLoad);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return trackEvent;
};

export default useTrackAmplitudeEvent;
